import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  OnInit,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IconRegistryService } from '@rd/core/services/icon-registry/icon-registry.service';
import { NumberService } from '@rd/core/services/number/number.service';
import { LoyaltyProgramHelper } from '@rd/helpers/loyalty-program.helper';
import { LoyaltyCurrency, LoyaltyProgram } from '@rd/types';
import { TransferConnectV2SettingService } from '../../services/transfer-connect-v2-setting/transfer-connect-v2-setting.service';

type ComponentRenderState = 'loading' | 'content';

@Component({
  selector: 'rd-tcv2-loyalty-programs-list-item-mobile',
  templateUrl: './loyalty-programs-list-item-mobile.component.html',
  styleUrls: ['./loyalty-programs-list-item-mobile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TcV2LoyaltyProgramsListItemMobileComponent implements OnInit {
  @Input() loyaltyProgram: LoyaltyProgram;
  @Input() loading: boolean;
  @Input() loyaltyCurrencySelected: LoyaltyCurrency;

  @HostBinding('class.rd-tcv2-loyalty-programs-list-item-mobile')
  componentClass = true;

  constructor(
    protected loyaltyProgramHelper: LoyaltyProgramHelper,
    protected numberService: NumberService,
    protected translateService: TranslateService,
    protected iconRegistryService: IconRegistryService,
    protected transferConnectV2SettingService: TransferConnectV2SettingService,
  ) {}

  ngOnInit(): void {
    this.registerIcons();
  }

  private registerIcons(): void {
    this.iconRegistryService.registerIcon('equal');
    this.iconRegistryService.registerIcon('chevron-right');
  }

  getComponentRenderState(): ComponentRenderState {
    if (this.loyaltyProgram) {
      return 'content';
    } else {
      return 'loading';
    }
  }

  checkoutUrl(): string {
    return this.loyaltyProgramHelper.checkoutUrl(this.loyaltyProgram);
  }

  loyaltyProgramImageUrl(): URL | null {
    return this.loyaltyProgram.pointsTransferCapability.logoUrl;
  }

  tenantCurrencyPointsParams(): { points_amount: string; currency: string } {
    return {
      points_amount: this.numberService.formatNumber(
        // @ts-ignore
        this.loyaltyProgram.transferRate.minimumTransfer,
      ),
      currency: this.translateService.instant(
        this.pointsCurrencyNameTranslationKey(),
      ),
    };
  }

  targetCurrencyPointsParams(): { points_amount: string; currency: string } {
    return {
      points_amount: this.numberService.formatNumber(
        // @ts-ignore
        this.loyaltyProgram.transferRate.targetMinimumTransfer,
      ),
      // @ts-ignore
      currency: this.loyaltyProgram.loyaltyCurrency.name,
    };
  }

  private pointsCurrencyNameTranslationKey(): string {
    if (
      this.transferConnectV2SettingService.loyaltyProgramNameAttribute ===
      'name'
    ) {
      return this.loyaltyCurrencySelected.name;
    } else {
      return this.loyaltyCurrencySelected.shortName;
    }
  }
}
